import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../components/table/styled-table-row";
import { Membership, MembershipRequest } from "../../../service/model/membership.model";
import { useState } from "react";
import MembershipForm from "./membership-form";
import { ConfirmationDialog } from "../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { deleteMembership, updateMembership } from "../membership.slice";
import { selectLoggedInUser } from "../../auth/auth.slice";
import TableActionButton from "../../../components/table/table-action-button";
import { EditIcon, DeleteIcon } from "../../../shared/icons";

interface TableRowProps {
    readonly membership: Membership
}

const MembershipTableRow: React.FC<TableRowProps> = ({ membership }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showMembershipForm, setShowMembershipForm] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;

    const handleDelete = () => {
        dispatch(deleteMembership(membership.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: MembershipRequest) => {
        loggedInUser && dispatch(updateMembership({ ...data, id: membership.id })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowMembershipForm(false);
            }
        });
    };

    return (
        <>
            <StyledTableRow key={membership.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Name</Box>{membership.name}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Amount</Box>{membership.amount}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Duration (Days)</Box>{membership.durationDays}</TableCell>
                {/* <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Expiry</Box>{node.branch.createdDate}</TableCell> */}
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    {/* <IconButton onClick={() => setShowMembershipForm(true)} sx={{color: `${theme.palette.secondary.main}`, paddingLeft: 0}}><VisibilityIcon /></IconButton> */}
                    <TableActionButton onClick={() => setShowMembershipForm(true)} label="Edit" icon={<EditIcon />} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                    {/* <Link className="btn" to="#" data-toggle="modal" data-target="#delete-member-modal" onClick={() => setShowDeleteDialog(true)}><DeleteIcon /></Link> */}
                </TableCell>
            </StyledTableRow>
            {showMembershipForm &&
                <MembershipForm membership={membership} editable={true} onClose={() => setShowMembershipForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default MembershipTableRow;